import SaleCommitTable from "../../../../Sale/components/Table/SaleCommitTable";

function CommitDetail({items})
{
    return (
        <SaleCommitTable items={items}/>
    )
}

export default CommitDetail;